import { TimelineMax } from 'gsap'
import { promiseTl } from '@/helpers'

import store from '@/store'

let nextTimeoutOnOut = setTimeout(() => {}, 0)

export default class Transitions {
  static in (to, from, next) {
    // console.log("IN")
    document.body.classList.remove('loading')

    const transitionType = store.state.transition.type
    const transitionComponents = store.state.transition.components

    if (transitionType == 'default') {
      setTimeout(() => {
        transitionComponents.default.hide()

      }, 500)
      if (next) next()
    } else if (transitionType == 'case') {
      transitionComponents.default.hideImgTransition()
      // transitionComponents.case.hide()
      if (next) next()
    }
    document.documentElement.classList.remove('is-loading')

    store.state.transition.type = 'default'
  }

  static out (to, from, next) {

    const transitionType = store.state.transition.type
    const transitionComponents = store.state.transition.components

    if (transitionType == 'default') {
      transitionComponents.default.show()
      clearTimeout(nextTimeoutOnOut)
      nextTimeoutOnOut = setTimeout(() => {
        if (next) next()
        document.documentElement.classList.add('is-loading')
        document.body.classList.add('loading')
      }, 1500)
    } else if (transitionType == 'case') {
      setTimeout(() => {
        transitionComponents.default.showImgTransition()
      }, 300)
      clearTimeout(nextTimeoutOnOut)
      nextTimeoutOnOut = setTimeout(() => {
        if (next) next()
      }, window.innerWidth > 813 ? 1700 : 1000)
    }
  }
}
